











import { Component, Vue } from 'vue-property-decorator';
import OtSwitch from '@/components/global/ot-switch.vue';

@Component({
  components: {
    OtSwitch,
  },
})
export default class OtSwitchWrapper extends Vue {
  // * PROPS

  // * DATA
  private data: unknown;

  // * COMPUTED

  // * WATCHERS

  // * METHODS

  // * LIFECYCLE
}
